import updateReportDateReducer from "./updateReportDateReducer";

const reportDateReducers = {
    updateReportDate: updateReportDateReducer
};

export default reportDateReducers